function attachEventToButton() {
    const button = button_id ? document.getElementById(button_id) : document.querySelector(`button.${button_class}`);
    if (button) {
        button.addEventListener("click", function () {
            fbq(tracking, event_name, properties);
        });
    }
}

if (event_name) {
    if (button_id || button_class) {
        document.addEventListener('DOMContentLoaded', attachEventToButton);
        const checkButtonInterval = setInterval(() => {
            const button = button_id ? document.getElementById(button_id) : document.querySelector(`button.${button_class}`);
            if (button) {
                clearInterval(checkButtonInterval);
                attachEventToButton();
            }
        }, 1000);
    }
    else
        fbq(tracking, event_name, properties);
}